import styled from 'styled-components';
import { theme } from '../../../../../global';

export const HeaderDesktopWrapper = styled.div`
  display: none;

  @media (min-width: 1100px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    z-index: 1000;
    position: fixed;
    left: 0px;
    top: 0px;
  }
`;

export const HeaderDesktopContainer = styled.div`
  background-color: ${theme.colors.header};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 72px;
  border-bottom: 1px solid #b0b0ed;
  gap: calc(100vw / 10);
  padding: 0 ${theme.spacings.s12};
`;

export const HeaderDesktopContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacings.s12};
`;

export const IconWrapper = styled.div`
  width: 48px;
  height: 32px;
`;

export const HeaderTitle = styled.h1`
  font-weight: 500;
  font-family: 'Montserrat';
  color: ${theme.colors.white};
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${theme.spacings.s24};
  min-width: 368px;
`;

export const ButtonLink = styled.a`
  font-weight: 700;
  font-family: 'Montserrat';
  color: ${theme.colors.white};
  font-size: 14px;
  line-height: 20px;
`;

export const LeftButtonsContainer = styled.div`
  width: 368px;
  display: flex;
  justify-content:flex-end;
  gap: ${theme.spacings.s24};
`;
